import { render, staticRenderFns } from "./liveclass.vue?vue&type=template&id=2255c8a3&scoped=true"
import script from "./liveclass.vue?vue&type=script&lang=js"
export * from "./liveclass.vue?vue&type=script&lang=js"
import style0 from "./liveclass.vue?vue&type=style&index=0&id=2255c8a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2255c8a3",
  null
  
)

export default component.exports